import AuthStyle from './AuthStyle.module.css';
import { useEffect, useState } from "react";
import {responseMsg} from "../../common/ResponseMsg";
import AuthEditModal from "./AuthEditModal";
import AuthAddModal from "./AuthAddModal";
import ManagementPage from '../../../shared/components/ManagementPage';
import ManageButton from '../../../shared/components/ManageButton';
import Text from '../../../shared/components/Text';
import Input from '../../../shared/components/Input';
import useDevice from '../../../shared/hooks/useDevice';
import Padding from '../../../shared/components/Padding';
import Card from '../../../shared/components/Card';
import Flex from '../../../shared/components/Flex';
import GridInfo from '../../../shared/components/GridInfo';
import Spacer from '../../../shared/components/Spacer';
import { AgGridReact } from 'ag-grid-react';
import ScrollModal from '../../common/ScrollModal';
import getRowNo from '../../../shared/components/utils/getRowNo';
import AgGridTable from '../../common/AgGridTable';
import { useAlert } from '../../../shared/components/AlertProvider';
import { addTooltipField } from '../../../shared/utils/gridTitleUtil';

function Auth({name}) {
    const [render, setRender] = useState(false);
    const [searchObj, setSearchObj] = useState({req: {encodedNm: ""}});
    const [updateModal, setUpdateModal] = useState({});
    const [addModal, setAddModal] = useState({});
    const [roles, setRoles] = useState();
    const [menus, setMenus] = useState();
    const [selectedRole, setSelectedRole] = useState();
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const showAlert = useAlert();

    const rendering = () => {
        closeUpdateModal();
        closeAddModal();
        setRender(!render);
    }

    // 모달 (등록)
    const openAddModal = (cell) => {
        setAddModal({
            ...addModal,
            open: true,
            close: closeAddModal,
            main: <AuthAddModal
                rendering={rendering}
            />,
        });
    };

    const closeAddModal = () => {

        setAddModal({
            ...addModal,
            open : false,
        });
    };

    // 모달 (수정)
    const openUpdateModal = (cell) => {
        const modalMenus = menus.map(ele => {
            ele['modal_select'] = ele.select;
            ele['modal_insert'] = ele.insert;
            ele['modal_update'] = ele.update;

            return ele;
        })

        setUpdateModal({
            ...updateModal,
            open: true,
            close: closeUpdateModal,
            main: <AuthEditModal
                            menus={modalMenus}
                            selectedRole={selectedRole} 
                            rendering={rendering}
                        />,
        });
    };

    const closeUpdateModal = () => {

        setUpdateModal({
            ...updateModal,
            open : false,
        });
    };

    const checkBoxRenderer = (cell) => {
        const col = cell.colDef;
        const data = cell.data;

        if (data[col.field] !== 'notPage' && data[col.field]) {

            return (
                <Flex justifyContent='center' alignItems='center' height='100%'>
                    <img 
                        src='/images/ico_check_orange.png' 
                        alt="Checked"
                        style={{ scale: '1.2'}}
                    />
                </Flex>
            )
        }
    }

    const leftGridConfig = {
        columnDefs: addTooltipField(
            [
                { headerName: '번호', field: 'rowNo',width: 65},
                { headerName: '권한ID', field: 'name', width: 160, cellStyle: { textAlign: "left" }},
                { headerName: '권한명', field: 'encodedNm', width: 130, cellStyle: { textAlign: "left" }},
                { headerName: '비고', field: 'comment', width: 220, cellStyle: { textAlign: "left" }},
            ]
        ),
        pagination: false,
        onCellClicked: (cell) => setSelectedRole(cell.data),
        onCellDoubleClicked: (cell) => openUpdateModal(cell),
        rowData: roles,
        rowSelection: 'single',
    };

    const rightGridConfig = {
        columnDefs: addTooltipField(
            [
                { headerName: '번호', field: 'rowNo',width: 65},
                { headerName: 'Level', field: 'depth', width: 80},
                { headerName: '시스템명', field: 'name', width: 283, cellStyle: { textAlign: "left" }},
                { headerName: 'URL', field: 'url', width: 300, cellStyle: { textAlign: "left" }},
                { headerName: '조회', field: 'select', cellRenderer: checkBoxRenderer, width: 155},
                { headerName: '등록', field: 'insert', cellRenderer: checkBoxRenderer, width: 155},
                { headerName: '수정', field: 'update', cellRenderer: checkBoxRenderer, width: 155},
            ]
        ),
        suppressRowHoverHighlight: true,
        rowData: menus,
    };

    const createMenusArr = (arr,menus) => {
        if (!menus) return;

        menus.forEach(ele => {
            arr.push(ele);
            createMenusArr(arr,ele.children);
        });
    }

    const apiGetRoleList = (page) => {
        let url = '/api/system/roles?'
        const pagingSize = 20;

        if (page) {
            url += `page=${page-1}&`
            url += `size=${pagingSize}&`
        }

        if(searchObj) {
            Object.keys(searchObj.req).forEach(ele => {
                if (searchObj.req[ele]) {
                    url += `${ele}=${searchObj.req[ele]}&`
                }
            })
            
            fetch(url,{
                method:"GET"
            })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setSelectedRole(json.data[0]);

                    setRoles(getRowNo(json.data));

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
        } 
    }

    const search = () => {
        const value = document.getElementById("encodedNm")?.value.trim() ?? "";
        setSearchObj({req: {encodedNm: value}})
    }

    useEffect(() => {
        apiGetRoleList();
    },[render,searchObj])

    useEffect(() => {

        fetch("/api/system/menus",{
            method:"GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    const menus = [];
                    createMenusArr(menus,json.data);

                    menus.forEach(ele => {
                        if (!ele.children.length) {
                            ele.select = selectedRole?.menus.find(menu => menu.id === ele.id) ? true : false;
                            ele.insert = selectedRole?.privileges.find(privilege => privilege.type === 'I' && privilege.menuId === ele.id) ? true : false;
                            ele.update = selectedRole?.privileges.find(privilege => privilege.type === 'U' && privilege.menuId === ele.id) ? true : false;
                        } else {
                            ele.select = null
                            ele.insert = null
                            ele.update = null
                        }
                    })

                    setMenus(getRowNo(menus));

                }  else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
            
    },[render,roles,selectedRole])

    return (
        <ManagementPage
            title='권한관리'
            actions={
                <>
                    <ManageButton 
                        onClick={search} 
                        btnType='search'
                    />
                    <ManageButton onClick={openAddModal} btnType='regist'/>
                </>
            }
            searchArea={
                <>
                    <Text size={"sm"} style={{width: "70px", flexShrink: 0}}>권한명</Text>
                    <Input 
                        id='encodedNm' 
                        fullWidth={isMobile} 
                        name="roleNm" 
                        placeholder='권한명을 입력해 주세요' 
                        style={{flex: 1}} 
                        maxLength={200} 
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                search()
                            }
                        }}
                        autoFocus
                    />
                </>
            }
        >
            <Flex flexDirection={isMobile ? "column" : "row"} gap={15} style={{ flex: 1 }}>
                <div className={AuthStyle.left}style={{ flex: 1, minWidth: 0 }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: isMobile ? "406px" : "100%",
                        }}
                    >
                        <Card fullWidth style={{ flex: 1, display: 'flex' }}>
                            <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column"}}>
                                <GridInfo title='권한 목록' width={490}
                                        content='항목을 클릭하면 선택한 권한의 화면별 권한 목록이 오른쪽 목록에 표시됩니다.
                                                 항목을 더블클릭하면 선택한 권한을 수정하는 화면이 열립니다.' />
                                <Spacer direction='vertical' size={15} />
                                <AgGridTable
                                    rowData={roles}
                                    columnDefs={leftGridConfig.columnDefs}
                                    onRowClicked={(row) => {
                                        setSelectedRole(row.data);
                                    }}
                                    onRowDoubleClicked={(params) => {
                                        openUpdateModal(params.data);
                                    }}
                                    selectedRow={selectedRole}
                                    tooltipShowDelay={0}
                                    tooltipHideDelay={2000}
                                />
                            </Padding>
                        </Card>
                    </div>
                </div>

                <div className={AuthStyle.right} style={{ flex: 2, minWidth: 0 }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: isMobile ? "406px" : "100%",
                        }}
                    >
                        <Card fullWidth style={{ flex: 1, display: 'flex' }}>
                            <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                <Text weight={"bold"}>화면별 권한 목록</Text>
                                <Spacer direction='vertical' size={15} />
                                <AgGridReact
                                    rowData={menus}
                                    columnDefs={rightGridConfig.columnDefs}
                                    tooltipShowDelay={0}
                                    tooltipHideDelay={2000}
                                />
                            </Padding>
                        </Card>
                    </div>
                </div>
            </Flex>

            <ScrollModal
                headerText="권한 등록"
                size={"595px"}
                modal={addModal}
            >
            </ScrollModal>

            <ScrollModal
                headerText="권한 수정"
                size={"1214px"}
                modal={updateModal}
            >
            </ScrollModal>
        </ManagementPage>
    );
}

export default Auth;